module.exports = __webpack_public_path__ + "static/media/homepage1.84db406c.webp";